<template>
<div>
<v-layout v-if="!isDataLoaded"
    align-center
    justify-space-around
    wrap
    fill-height
    style="background:var(--background-grey); height:100vh;"
    >
    <v-progress-circular
        indeterminate
        color="primary"
        :size="50">
        </v-progress-circular>
    </v-layout>
<div class="invoice-screen" v-if="isDataLoaded">
<div class="invoice-builder" :class="`show-${showPanel}`">
      <div class="invoice-editor-panel elevation-0 invoice-panel">
          <div class="invoice-editor-panel--body pt-2">
          <div v-show='group.isFirstInvoice'>
            <v-toolbar  dense flat color="secondary" class="pt-2">
              <v-toolbar-title class="body-2">Get started</v-toolbar-title>
            </v-toolbar>
            <v-card flat color="secondary" class="px-2 py-0">
              <v-card-text class="pt-2 pb-3">
                <p class="body-small mb-1">Let's add some details about your business so we can send your first invoice.</p>
              </v-card-text>
            </v-card>
            <v-stepper v-model="stepperNode" vertical style="padding-left:1px; box-shadow:none; background-color:transparent;" >
            <v-stepper-step :complete="stepperNode > 1" step="1">
              <span class="body-small">Branding</span>
            </v-stepper-step>

            <v-stepper-content step="1">
              <v-card class="mb-3" flat color="secondary">
              <v-radio-group  v-model="invoice.useLogo" hide-details row class="mt-0 pt-2 mb-3">
                <v-radio color="primary" label="I have a logo" :value='true' ></v-radio>
                <v-radio color="primary" label="Use my business name" :value='false'></v-radio>
              </v-radio-group>
              <v-slide-y-transition>
              <div v-show='invoice.useLogo'>
              <p class="caption light" v-if="!imageUrl">A .png or .jpg file 500px by 500px min.</p>
              <v-layout row wrap v-if="imageUrl" align-center justify-center fill-height>
                <v-flex xs12>
                <v-slider
                  :min="50"
                  :max="255"
                  hide-details
                  label="Size"
                  @focus="stepperNode = 1"
                  v-model="invoice.logoWidth"></v-slider>
                </v-flex>
              </v-layout>
                <v-layout row wrap pl-0>
                  <v-flex xs12 pl-0 mt-3>
                    <v-btn v-if="!imageUrl" class="mr-1 tinybut  white--text text-none ml-0" small depressed color="error" @click="onPickFile" >{{uploadLabel}}</v-btn>
                    <input
                    type="file"
                    style="display:none;"
                    ref="fileInput"
                    accept="images/*"
                    @change="onFilePicked">
                    <v-btn small depressed color="error" @click="removeLogo" v-if="imageUrl" class="mr-1 tinybut  white--text text-none">remove</v-btn>
                    <v-btn color="primary" small depressed @click="stepperNode = 2" class="tinybut  white--text text-none" :disabled="invoice.useLogo === ''">continue</v-btn>
                  </v-flex>
                </v-layout>
              </div>
              </v-slide-y-transition>
              <v-slide-y-transition>
              <div v-show="!invoice.useLogo && invoice.useLogo !== ''">
                  <v-textarea
                    name="logoName"
                    label="Your business name"
                    id="logoName"
                    v-model="invoice.logoName"
                    placeholder=" "
                    rows="2"
                    @focus="stepperNode = 1"
                    hint="Use enter key to add line breaks"
                    required></v-textarea>
                  <v-slider
                  :min="10"
                  :max="50"
                  hide-details
                  label="Text size"
                  @focus="stepperNode = 1"
                  v-model="invoice.logoNameSize"></v-slider>
                  <v-btn color="primary" small depressed @click="stepperNode = 2" class="tinybut  white--text text-none mt-2" :disabled="invoice.useLogo === ''">continue</v-btn>
              </div>
              </v-slide-y-transition>
              </v-card>
            </v-stepper-content>
            <v-stepper-step :complete="stepperNode > 2" step="2">Business details</v-stepper-step>

            <v-stepper-content step="2">
              <v-card class="mb-2" flat color="secondary">
                <v-layout>
                  <v-flex column wrap>
                        <address-fields
                        :companyAddress.sync="invoice.groupAddress"
                        :groupAddress1.sync="invoice.groupAddress1"
                        :groupAddress2.sync="invoice.groupAddress2"
                        :groupCityRegion.sync="invoice.groupCityRegion"
                        :groupCountyState.sync="invoice.groupCountyState"
                        :groupPostcode.sync="invoice.groupPostcode"
                        :groupCountry.sync="invoice.groupCountry"
                      ></address-fields>
                  </v-flex>
                </v-layout>
                <v-layout row wrap pl-0>
                  <v-flex xs12 pl-0>
                    <v-btn color="error" small depressed @click="stepperNode = 1" class="mr-1 tinybut  white--text text-none ml-0">back</v-btn>
                    <v-btn color="primary" small depressed @click="stepperNode = 3" class="tinybut  white--text text-none">continue</v-btn>
                  </v-flex>
                </v-layout>
              </v-card>
            </v-stepper-content>

            <v-stepper-step :complete="stepperNode > 3" step="3">Payment &amp; Terms
            </v-stepper-step>

            <v-stepper-content step="3">
              <v-card class="mb-2" flat color="secondary">
                <span class="fake-label">This commonly includes terms and payment instructions.</span>
                <v-textarea
                @focus="stepperNode = 3"
                name="paymentTerms"
                label=" "
                id="paymentTerms"
                v-model="invoice.paymentTerms"
                placeholder=" "
                auto-grow
                rows="5"
                required
                ></v-textarea>
                <v-layout row wrap pl-0>
                  <v-flex xs12 pl-0>
                    <v-btn color="error" small depressed @click="stepperNode = 2" class="mr-1 tinybut  white--text text-none ml-0">back</v-btn>
                    <v-btn color="primary" small depressed @click="stepperNode = 4" class="tinybut  white--text text-none">continue</v-btn>
                  </v-flex>
                </v-layout>
                </v-card>
            </v-stepper-content>
            <v-stepper-step :complete="stepperNode > 4" step="4">Invoice numbering
            </v-stepper-step>

            <v-stepper-content step="4">
              <v-card class="mb-2" flat color="secondary">
                <span class="fake-label">Choose to automatically number your invoices sequentially or manage them manually.</span>
                <invoice-number-format
                  v-bind:autoIncrement.sync="group.autoIncrement"
                  v-bind:autoIncrementPrefix.sync="group.autoIncrementPrefix"
                  v-bind:nextNumber.sync="group.nextNumber"
                  v-on:changedinvoicenumber="liveUpdateInvoiceNumber"
                  width='narrow'
                  :initial='true'
                  ></invoice-number-format>
                <v-layout row wrap pl-0>
                  <v-flex xs12 pl-0>
                    <v-btn color="error" small depressed @click="stepperNode = 3" class="mr-1 tinybut  white--text text-none ml-0">back</v-btn>
                    <v-btn color="primary" small depressed @click="stepperNode = 5" class="tinybut  white--text text-none">continue</v-btn>
                  </v-flex>
                </v-layout>
                </v-card>
            </v-stepper-content>

            <v-stepper-step step="5">Completed</v-stepper-step>
            <v-stepper-content step="5">
              <v-card flat color="secondary">
                  <p class="body-small mb-3">You're done!
Click continue to begin sending your first invoice or back to change something.</p>
                <v-layout row wrap pl-0>
                  <v-flex xs12 pl-0>
                    <v-btn color="error" small depressed @click="stepperNode = 4" class="mr-1 tinybut  white--text text-none ml-0">back</v-btn>
                    <v-btn color="primary" small depressed @click="firstInvoiceWizardDone()" class="tinybut  white--text text-none">continue</v-btn>
                  </v-flex>
                </v-layout>
              </v-card>
            </v-stepper-content>
          </v-stepper>
          </div>
            <v-tabs
              v-model="active"
              color="secondary"
              height="60"
              :hide-slider='true'
              v-show='!group.isFirstInvoice'
              class="m-0 p-0 modal-tabs"
              >
                <v-tab key="Details" href="#Details" :ripple='false' class="m-0 p-0" style="padding-left:22px;">
                  <span class="tab-button">Invoice details</span>
                </v-tab>
                <v-spacer></v-spacer>
                <v-tab key="Design" href="#Design" :ripple='false' class="m-0 p-0 pr-4">
                    <span class="tab-button rounded px-1"><v-icon small>settings</v-icon></span>
                </v-tab>
                <v-tab-item value="Details" >
                  <div data-v-step="editpanel" class="invoice-card" style="cursor:pointer;" @click="$refs.editinvdet.toggleDialog()">
                    <v-layout flex justify-center align-center>
                      <v-flex class="body-2">Invoice info</v-flex>
                      <v-spacer></v-spacer>
                      <edit-invoice-details-modal
                      ref="editinvdet"
                      :invoice="invoice"
                      :autoIncrement="this.group.autoIncrement"
                      :invoicedDateFormatted="invoicedDateFormatted"
                      :displayedInvoiceNumber="displayedInvoiceNumber"
                      @return-invoice-details="clickedShowInvoiceDetailsModal"
                      ></edit-invoice-details-modal>
                      <get-invoice-number
                      ref="getInvoiceNumber"
                      :invoice="invoice"
                      v-model="showInvoiceNumberModal"
                      @return-invoice-details="returningInvoiceNumber"
                      ></get-invoice-number>
                    </v-layout>
                    <v-layout column pt-2>
                      <p class="body-smaller font-weight-medium mb-0">Invoice number: <span class="font-weight-regular" v-html="displayedInvoiceNumber || `<em class='error--text'>Required</em>`"></span></p>
                      <p class="body-smaller font-weight-medium mb-0">PO number: <span class="font-weight-regular" v-html="invoice.poNumber || `<em class='subtle'>Optional</em>`"></span></p>
                      <p class="body-smaller font-weight-medium mb-0">Invoice date: <span class="font-weight-regular" v-html="invoicedDateFormatted || `<em class='subtle'>Not Set</em>`"></span></p>
                      <p class="body-smaller font-weight-medium mb-0" v-if="!invoice.note">Note: <span class="font-weight-regular"><em class='subtle'>None</em></span></p>
                      <p class="body-smaller font-weight-medium mb-0" v-else>Note: <span class="font-weight-regular" v-html="truncatedNoteText"></span></p>
                    </v-layout>
                  </div>
                  <div class="invoice-card" style="cursor:pointer;" @click="lineItemDialog = true">
                    <v-layout flex justify-center align-center>
                      <v-flex class="body-2">Job items</v-flex>
                      <v-spacer></v-spacer>
                      <v-dialog
                      persistent
                      v-model="lineItemDialog"
                      max-width="500px"
                      :fullscreen="$vuetify.breakpoint.xsOnly"
                      >
                        <span class="edit-button" slot="activator">edit</span>
                        <v-card :class="{'no-border': $vuetify.breakpoint.xsOnly}">
                          <v-container class="modal-pad">
                            <v-layout row align-center wrap mb-1>
                              <v-flex xs10 style="height:30px;">
                                <span class="subheading">Edit job items</span>
                              </v-flex>
                              <v-flex xs2 class="text-xs-right">
                                <span class="done-button" @click="lineItemDialog = false">done</span>
                              </v-flex>
                            </v-layout>
                            <v-layout row v-if="invoice.status === 'Sent'">
                              <v-flex xs12>
                                <v-alert color="warning" icon="info" value="true">
                                  This invoice has been Sent.
                                </v-alert>
                              </v-flex>
                            </v-layout>
                            <v-layout column pt-2>
                            <line-items
                              :lineItems="invoice.lineItems"
                              :newLineItemKey="newLineItemKey"
                              :itemAmount="invoice.amount"
                              :itemTotalTaxPortion="invoice.totalTaxPortion"
                              :itemTotalNetAmount="invoice.totalNetAmount"
                              :itemTitle="invoice.title"
                              :itemTaxIncluded="invoice.taxIncluded"
                              @create-new-key="getLineItemKey"
                              @line-items-output="updateInvoiceFromLineItems"
                            />
                            </v-layout>
                            <v-layout  wrap >
                            </v-layout>
                          </v-container>
                        </v-card>
                      </v-dialog>
                    </v-layout>
                    <v-layout pt-2>
                      <v-flex xs6><span class="body-smaller font-weight-medium">Job Description</span></v-flex>
                      <v-flex xs1 pt-0 offset-xs1 class="text-xs-left" v-show="invoice.chargeTax"><span class="body-smaller font-weight-medium">{{group.taxLabel || "VAT"}}</span></v-flex>
                      <v-flex xs3 offset-xs1 pt-0 class="text-xs-left" :class="{ xs4: !invoice.chargeTax}">
                        <span class="body-smaller font-weight-medium">Cost </span>
                      </v-flex>
                    </v-layout>
                    <div class="pb-0">
                      <v-layout v-for="line in invoice.lineItems" :key='line.id'>
                        <v-flex xs6><span class="fake-label">{{line.description}}</span></v-flex>
                        <v-flex xs1 pt-0 offset-xs1 class="text-xs-left" v-show="invoice.chargeTax"><span class="fake-label">{{line.taxRate}}&percnt;</span></v-flex>
                        <v-flex xs3 offset-xs1 pt-0 class="text-xs-left" :class="{ xs4: !invoice.chargeTax}">
                          <span class="fake-label">{{line.amount | toCurrency(invoice.lang, invoice.currCode)}} </span>
                        </v-flex>
                      </v-layout>
                    </div>
                  </div>
                  <div class="invoice-card shorten" style="cursor:pointer;" @click="$refs.editclientdet.toggleDialog()">
                    <v-layout flex justify-center align-center>
                      <v-flex class="body-2">Client details</v-flex>
                      <v-spacer></v-spacer>
                      <edit-client-details-modal
                      ref="editclientdet"
                      :invoice="invoice"
                      :client="client"
                      @return-client-details="clickedShowClientDetailsModal"
                      >
                      </edit-client-details-modal>
                    </v-layout>
                    <v-layout column pt-2 class="client-details-shorten">
                        <p class="body-smaller font-weight-medium mb-0"><span class="font-weight-regular" v-html="invoice.contact || `<em class='subtle'>No Contact Name</em>`"></span></p>
                        <p class="body-smaller font-weight-medium mb-0"><span class="font-weight-regular" v-html="invoice.clientName || `<em class='subtle'>No Client Name</em>`"></span></p>

                        <p v-for="item in emailList" :key="item.index"
                        class="body-smaller font-weight-medium mb-0"><span class="font-weight-regular">
                          {{item}}
                        </span></p>
                        <p class="body-smaller font-weight-medium mb-0"><span class="font-weight-regular" ><em v-if="emailList.length === 0" class='subtle'>No Client Email</em></span></p>

                        <p class="body-smaller font-weight-medium mb-0"><pre><span class="font-weight-regular" v-html="invoice.clientAddress || `<em class='subtle'>No Address</em>`"></span></pre></p>
                        <p class="body-smaller font-weight-medium mb-0"><pre><span class="font-weight-regular" v-html="invoice.clientAddress2|| `<em class='subtle'>No Address2</em>`"></span></pre></p>
                        <p class="body-smaller font-weight-medium mb-0"><pre><span class="font-weight-regular" v-html="invoice.clientTown || `<em class='subtle'>No Town</em>`"></span></pre></p>
                        <p class="body-smaller font-weight-medium mb-0"><pre><span class="font-weight-regular" v-html="invoice.clientCounty || `<em class='subtle'>No County</em>`"></span></pre></p>
                        <p class="body-smaller font-weight-medium mb-0"><pre><span class="font-weight-regular" v-html="invoice.clientCountry || `<em class='subtle'>No Country</em>`"></span></pre></p>
                        <p class="body-smaller font-weight-medium mb-0"><span class="font-weight-regular" v-html="invoice.postCode || `<em class='subtle'>No Post Code</em>`"></span></p>
                    </v-layout>
                  </div>
                  <div class="invoice-card">
                    <v-layout flex justify-center align-center>
                      <v-flex class="body-2">Chase emails</v-flex>
                      <v-spacer></v-spacer>
                    </v-layout>
                    <v-layout column pt-3 v-if="group.sendChasers">
                      <p class="body-smaller mb-0">Enable chase emails for this invoice.</p>
                      <v-switch color="primary" class="small-switch" :label='invoice.chaseable ? "Chase emails enabled" : "Chase emails disabled"'
                        v-model="invoice.chaseable"
                        @change="onChaseSwitchChange"
                      ></v-switch>
                    </v-layout>
                    <v-layout column v-else pt-3>
                      <p class="d-block body-smaller font-weight-medium mb-2">Chase emails are turned off in settings.</p>
                      <v-btn style="margin-left:-1px" class="tinybut primary white--text" to="/settings/chaseemails" small depressed>
                        Setup chase emails
                      </v-btn>
                    </v-layout>
                    <get-invoice-to-email
                      ref="getInvoiceEmailTo"
                      :emailList="emailList"
                      v-model="showInvoiceEmailToModal"
                      @return-emailList-details="returningInvoiceEmailTo"
                      ></get-invoice-to-email>
                  </div>
                  <div class="invoice-card">
                    <v-layout flex justify-center align-center>
                      <v-flex class="body-2">Online payments</v-flex>
                      <v-spacer></v-spacer>
                    </v-layout>
                    <v-layout column pt-3 v-if="group.stripeConnect !== null && group.stripeConnect !== undefined">
                      <p class="body-smaller mb-0">Enable online payments for this invoice.</p>
                      <v-switch color="primary" class="small-switch" :label='invoice.payable ? "Online payments enabled" : "Online payments disabled"'
                        v-model="invoice.payable"
                        @change="onStripeSwitchChange"
                      ></v-switch>
                    </v-layout>
                    <v-layout column v-else pt-3>
                      <p class="d-block body-smaller font-weight-medium mb-2">Allow this invoice to be paid online via Stripe.com</p>
                      <v-btn style="margin-left:-1px" class="tinybut primary white--text" @click="showStripeModal = !showStripeModal" small depressed>
                        Setup Stripe
                      </v-btn>
                    </v-layout>
                  </div>
                </v-tab-item>
                <v-tab-item value="Design">
                  <v-divider></v-divider>
                  <div class="invoice-card">
                    <v-layout flex justify-center align-center pb-2>
                      <v-flex class="body-2">Logo</v-flex>
                      <v-spacer></v-spacer>
                    </v-layout>
                    <v-radio-group  v-model="invoice.useLogo" hide-details row class="mt-0 pt-2 mb-3">
                      <v-radio color="primary" label="I have a logo" :value='true' ></v-radio>
                      <v-radio color="primary" label="Use my business name" :value='false'></v-radio>
                    </v-radio-group>
                    <v-slide-y-transition>
                      <div v-show='invoice.useLogo'>
                        <v-layout row wrap>
                          <v-flex xs12 pb-0>
                            <span class="body-smaller pb-2 d-block">A .png or .jpg file 500px by 500px min.</span>
                          </v-flex>
                        </v-layout>
                        <v-layout row wrap v-if="imageUrl">
                          <v-flex xs12 md3 mt-3 >
                              <p class="body-small">Size</p>
                          </v-flex>
                          <v-flex xs12 md6>
                          <v-slider
                            :min="50"
                            :max="255"
                            v-model="invoice.logoWidth"></v-slider>
                            </v-flex>
                        </v-layout>
                        <v-layout row wrap>
                            <v-flex xs12 md6 class="pb-0 pt-0" :class="$vuetify.breakpoint.smAndDown ? '' : 'pr-1'">
                              <v-btn small block depressed color="primary" @click="onPickFile">{{uploadLabel}}</v-btn>
                              <input
                              type="file"
                              style="display:none;"
                              ref="fileInput"
                              accept="images/*"
                              @change="onFilePicked">
                            </v-flex>
                            <v-flex xs12 md6 :class="$vuetify.breakpoint.smAndDown ? '' : 'pl-1'">
                              <v-btn small block depressed color="error" @click="removeLogo" v-if="imageUrl">delete</v-btn>
                            </v-flex>
                          </v-layout>
                        </div>
                        </v-slide-y-transition>
                      <v-slide-y-transition>
                        <div v-show="!invoice.useLogo && invoice.useLogo !== ''">
                          <v-textarea
                            name="logoName"
                            label="Your business name"
                            id="logoName"
                            v-model="invoice.logoName"
                            placeholder=" "
                            rows="2"
                            hint="Use enter key to add line breaks"
                            required></v-textarea>
                          <v-slider
                          :min="10"
                          :max="50"
                          hide-details
                          label="Text size"
                          @focus="stepperNode = 1"
                          v-model="invoice.logoNameSize"></v-slider>
                          <v-btn color="primary" small depressed @click="onSaveInvoice" class="tinybut  white--text text-none mt-2" :disabled="invoice.useLogo === ''">Save</v-btn>
                      </div>
                      </v-slide-y-transition>
                  </div>
                  <div class="invoice-card" style="cursor:pointer;" @click="$refs.editbusinessdet.toggleDialog()">
                    <v-layout flex justify-center align-center>
                      <v-flex class="body-2">Business details</v-flex>
                      <v-spacer></v-spacer>
                      <edit-business-details-modal
                      ref="editbusinessdet"
                      :invoice="invoice"
                      @return-business-details="clickedShowBusinessDetailsModal"
                      ></edit-business-details-modal>
                    </v-layout>
                    <v-layout column pt-2>
                        <p class="body-smaller font-weight-medium mb-0">{{ invoice.groupTitle}}<br>
                      <span v-html="invoice.groupAddress.replace(/(?:\r\n|\r|\n)/g, '<br>')"></span>
                      </p>
                    </v-layout>
                  </div>
                  <div class="invoice-card" style="cursor:pointer;" @click="$refs.editpaymentdet.toggleDialog()">
                    <v-layout flex justify-center align-center>
                      <v-flex class="body-2">Payment &amp; Terms</v-flex>
                      <v-spacer></v-spacer>
                      <edit-payment-details-modal
                      ref="editpaymentdet"
                      :invoice="invoice"
                      @return-payment-details="clickedShowPaymentDetailsModal"
                      ></edit-payment-details-modal>
                    </v-layout>
                    <v-layout column pt-2>
                        <p class="body-smaller font-weight-medium mb-0">
                      <span v-html="invoice.paymentTerms.replace(/(?:\r\n|\r|\n)/g, '<br>')"></span>
                      </p>
                    </v-layout>
                  </div>
                </v-tab-item>
            </v-tabs>
          </div>
        </div>
  <div class="invoice-preview-panel invoice-panel">
    <div v-if="invoice.status !== 'Unsent'" class="customer-link-contain ">
      <div class="customer-link">
        <div><v-icon>add_link</v-icon></div>
        <div>{{ customerLink }}</div>
        <div><v-btn color="primary" small depressed @click="copyCustomerLink">{{ copyLinkLabel }}</v-btn></div>
      </div>
    </div>
    <div class="invoice-preview-contain">
        <v-layout row v-if="error">
          <v-flex xs12>
            <app-alert @dismissed="onDismissed" :text="error.message" :color="error.colour"></app-alert>
          </v-flex>
        </v-layout>
        <invoice-preview
        :invoice="invoice"
        :imageUrl="imageUrl"
        :invoicedDateFormatted="invoicedDateFormatted"
        :displayedInvoiceNumber="displayedInvoiceNumber"
        ></invoice-preview>
    </div>
  </div>
  <div class="invoice-timeline-panel elevation-0 pt-1 invoice-panel">
    <!-- invoice controls -->
      <div class="invoice-controls-holder px-4 py-3">
        <div data-v-step="savebut" class="invoice-controls-button">
          <v-btn style="margin-left:0; margin-right:0;"  class="action-button-padding" depressed color="accent" @click="onOpenEmail()" v-if='invoice.status === "Unsent" || isNewInvoice'>send</v-btn>
          <v-btn style="margin-left:0; margin-right:0;"  class="action-button-padding" depressed color="accent" @click="onMarkAsPaid()" v-if='invoice.status === "Sent"'>Mark paid</v-btn>
          <v-btn style="margin-left:0; margin-right:0;"  class="action-button-padding" depressed color="accent" @click="onDownload()" v-if='invoice.status === "Paid"'>Download</v-btn>
          <v-menu ref="sendDropDown" data-v-step="dropdown" v-model="saveButDropDownState" offset-y left>
            <v-btn style="margin-left:-5px;" slot="activator" color="accent"  dark depressed class="px-1 actions-arrow">
              <v-icon class="dropdown">arrow_drop_down</v-icon>
            </v-btn>
            <v-list color="accent" dense>
              <v-list-tile @click="onSaveAndMarkAsSent()" v-if='invoice.status === "Unsent"' :key="1">
                <v-list-tile-title>Mark sent</v-list-tile-title>
              </v-list-tile>
              <!-- <v-list-tile @click="onSaveAndDownload()" :href='downloadLink' v-if='invoice.status === "Unsent"' :key="2"> -->
                <v-list-tile @click="onSaveAndDownload()" v-if='invoice.status === "Unsent"' :key="2">
                <v-list-tile-title>Download</v-list-tile-title>
              </v-list-tile>
              <v-list-tile @click="onCopyLink()" v-if='invoice.status === "Unsent"' :key="3">
                <v-list-tile-title>Get invoice link</v-list-tile-title>
              </v-list-tile>
              <v-list-tile @click="onOpenEmail()" v-if='invoice.status === "Sent"' :key="4">
                <v-list-tile-title>Resend email</v-list-tile-title>
              </v-list-tile>
              <v-list-tile @click="onCopyLink()" v-if='invoice.status === "Sent"' :key="5">
                <v-list-tile-title>Get invoice link</v-list-tile-title>
              </v-list-tile>
              <v-list-tile @click="onMarkAsUnSent()" v-if='invoice.status === "Sent"' :key="6">
                <v-list-tile-title>Mark unsent</v-list-tile-title>
              </v-list-tile>
              <!-- <v-list-tile @click="onSaveAndDownload()" :href='downloadLink' v-if='invoice.status === "Sent"' :key="5"> -->
              <v-list-tile @click="onSaveAndDownload()" v-if='invoice.status === "Sent"' :key="7">
                <v-list-tile-title>Download</v-list-tile-title>
              </v-list-tile>
              <v-list-tile @click="onMarkAsUnPaid()" v-if='invoice.status === "Paid"' :key="8">
                <v-list-tile-title>Mark unpaid</v-list-tile-title>
              </v-list-tile>
              <v-list-tile @click="onDeleteInvoice()" v-if='!isNewInvoice' :key="9">
                <v-list-tile-title>Delete</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
        </div>
        <span @click="onSaveAndDownload()" class="download-button"><download-icon ></download-icon></span>
        <span @click="onDeleteInvoice()" class="delete-button"><delete-icon ></delete-icon></span>
    </div>
    <!-- Invoice status -->
    <div class="px-4 pt-2 ">
      <span class="bold">status:</span> {{invoice.status}}
    </div>
    <div data-v-step="timeline" class="invoice-timeline-panel--body">
      <span class="px-4 pt-3 subtle font-weight-medium text--light-text">Timeline</span>
        <timeline :invoiceActivities="invoiceActivities" :client="client" :group="group" :invoice="invoice"></timeline>
    </div>
  </div>
</div>

</div>
<v-bottom-nav
      v-if="$vuetify.breakpoint.xsOnly"
      :active.sync="showPanel"
      :value="true"
      fixed
      color="mutedprimary"
      dense
    >
      <v-btn
        dark
        flat
        value="edit"
        class="bottab"
        active-class="bottabon"
      >
        <span>Edit</span>
      </v-btn>

      <v-btn
        dark
        flat
        value="preview"
        class="bottab"
        active-class="bottabon"
      >
        <span>Preview</span>
      </v-btn>

      <v-btn
        dark
        flat
        value="timeline"
        class="bottab"
        active-class="bottabon"
      >
        <span>{{mobileStatusText}}</span>
      </v-btn>
    </v-bottom-nav>
    <v-dialog
      v-model="emailDialog"
      max-width="400"
      :fullscreen="$vuetify.breakpoint.xsOnly"
    >
    <v-card :class="{'no-border': $vuetify.breakpoint.xsOnly}">
      <v-form v-model="emailvalid" ref="emailForm">
      <v-container class="modal-pad">
        <v-layout row align-center wrap mb-3>
          <v-flex xs10 style="height:30px;">
            <span class="subheading">Email the invoice</span>
          </v-flex>
          <v-flex xs2 class="text-xs-right">
            <v-btn class="close-float" fab flat medium @click="emailDialog = false">
              <v-icon >close</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs12 pt-0>
            <v-text-field
                v-model="emailFromName"
                name="fromName"
                label="From name"
                placeholder=" "
                id="fromName"
                type="text"
                required
                :rules="[input_required]"
                autocomplete="off"
                ></v-text-field>
          </v-flex>
          <v-flex xs12 pt-0>
            <v-text-field
                v-model="emailFrom"
                name="f"
                label="From"
                placeholder=" "
                id="f"
                type="text"
                required
                :rules="[input_required]"
                autocomplete="off"
                ></v-text-field>
          </v-flex>
          <v-flex xs12 >
            <v-combobox
            autocomplete="off"
            v-model="emailList"
            label="To:"
            multiple
            chips
            :items="client.emails"
            placeholder="Enter one or more recipient email addresses"
            dense
            deletable-chips
            ref="emailto"
            :rules="[emailRules]"
            validate-on-blur
            :delimiters="[',', ';', ' ']"
            @change="$refs.emailForm.validate();"
          ></v-combobox>
          </v-flex>
          <v-flex xs12>
            <v-text-field
                v-model="emailSubject"
                name="subject"
                label="Subject"
                placeholder=" "
                id="subject"
                type="text"
                required
                :rules="[input_required]"
                ></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-textarea
              name="emailMessage"
              label="Message"
              id="emailMessage"
              v-model="emailMessage"
              placeholder=" "
              hide-details
              auto-grow
              rows="5"
              ></v-textarea>
          </v-flex>
        </v-layout>
        <v-layout class="pt-2 mb-1" align-end justify-start row fill-height>
          <v-btn style="margin-top:10px; margin-left:0; margin-right:0;" class="action-button-padding" depressed color="primary" @click="onSendEmail" :disabled='!emailvalid'>Send</v-btn>
        </v-layout>
      </v-container>
      </v-form>
    </v-card>
  </v-dialog>
  <v-dialog
    v-model="showStripeModal"
    max-width="600px"
    :fullscreen="$vuetify.breakpoint.xsOnly"
  >
    <v-card>
      <v-container class="modal-pad">
        <v-layout row align-center wrap mb-3>
          <v-flex xs10 style="height:30px;">
            <span class="subheading">Customer payments</span>
          </v-flex>
          <v-flex xs2 class="text-xs-right">
            <v-btn flat class="mx-0" medium  @click="showStripeModal = false">
              Done
            </v-btn>
          </v-flex>
        </v-layout>
        <v-layout column pt-1>
          <customer-payments :invoiceId="invoice.id" @online-payments-change="onlinePaymentsChange"/>
        </v-layout>
        <v-layout  wrap >
        </v-layout>
      </v-container>
    </v-card>
  </v-dialog>
  <confirm ref="confirm"></confirm>
  <v-dialog
      v-model="pdfLoading"
      hide-overlay
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          Generating your PDF
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
<invoice-tour ref="invoiceTour" @closeDropdownMenu="closeDropdownMenu"  @gotoTab="gotoTab"></invoice-tour>
</div>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/database'
import 'firebase/functions'
import { formatDate } from '@/components/Mixins/formatDate'
import AddLineItem from '@/components/Invoice/AddLineItem'
import EditClientDetailsModal from '@/components/Invoice/EditClientDetailsModal'
import EditInvoiceDetailsModal from '@/components/Invoice/EditInvoiceDetailsModal'
import EditBusinessDetailsModal from '@/components/Invoice/EditBusinessDetailsModal'
import EditPaymentDetailsModal from '@/components/Invoice/EditPaymentDetailsModal'
import InvoicePreview from '@/components/Invoice/InvoicePreview'
import GetInvoiceNumber from '@/components/Invoice/GetInvoiceNumber'
import GetInvoiceToEmail from '@/components/Invoice/GetInvoiceToEmail'
import InvoiceNumberFormat from '@/components/Shared/InvoiceNumberFormat'
import Timeline from '@/components/Invoice/Timeline'
import Confirm from '@/components/Shared/Confirm'
import LineItems from '@/components/Shared/LineItems'
import CustomerPayments from '@/components/Shared/CustomerPayments'
import DownloadIcon from '@/components/Shared/DownloadIcon'
import DeleteIcon from '@/components/Shared/DeleteIcon'
import AddressFields from '@/components/Shared/AddressFields'
import { incrementAndMaintainNumberPadding } from '@/components/Mixins/incrementAndMaintainNumberPadding'
import InvoiceTour from '@/components/Shared/InvoiceTour'

export default {
  name: 'invoice',
  components: {
    AddLineItem,
    EditClientDetailsModal,
    EditInvoiceDetailsModal,
    EditBusinessDetailsModal,
    EditPaymentDetailsModal,
    InvoicePreview,
    GetInvoiceNumber,
    GetInvoiceToEmail,
    InvoiceNumberFormat,
    Timeline,
    Confirm,
    LineItems,
    CustomerPayments,
    DownloadIcon,
    DeleteIcon,
    AddressFields,
    InvoiceTour
  },
  mixins: [formatDate, incrementAndMaintainNumberPadding],
  data () {
    return {
      saveButDropDownState: false,
      pdfLoading: false,
      showStripeModal: false,
      showInvoiceNumberModal: false,
      showInvoiceEmailToModal: false,
      lineItemDialog: false,
      showPanel: 'edit',
      bottomNav: 'recent',
      stepperNode: 1,
      isDataLoaded: false,
      emailDialog: false,
      emailFromName: this.$store.getters.group.title,
      emailFrom: this.$store.getters.group.email,
      emailSubject: `Invoice from ${this.$store.getters.group.title}`,
      emailMessage: ``,
      tabs: ['Details', 'Design', 'Send'],
      active: null,
      isNewInvoice: true,
      menu_paid_date: false,
      deadlineDateFormatted: '',
      invoicedDateFormatted: '',
      group: this.$store.getters.group,
      imageUrl: this.$store.getters.group.logo,
      user: this.$store.getters.user,
      itemId: this.$route.params.invoice_id,
      newLineItemKey: '',
      invoice: {
        id: this.$route.params.invoice_id,
        title: '',
        clientName: '',
        amount: '',
        contact: '',
        poNumber: '',
        invoice_ref: '',
        invoiced_date: '',
        paid_date: '',
        chargeTax: '',
        taxRate: '',
        clientAddress: '',
        postCode: '',
        groupTitle: '',
        groupAddress: '',
        logo: this.imageUrl,
        logoWidth: 120,
        logoAlign: 'left',
        useLogo: this.$store.getters.group.useLogo || false,
        logoName: this.$store.getters.group.logoName || this.$store.getters.group.title,
        logoNameSize: this.$store.getters.group.logoNameSize || 20,
        paymentTerms: '',
        lineItems: [],
        note: '',
        status: 'Unsent',
        lang: this.$store.getters.group.lang,
        currCode: this.$store.getters.group.currCode,
        currSymbol: this.$store.getters.group.currSymbol,
        payable: false,
        taxIncluded: false,
        totalNetAmount: 0,
        totalTaxPortion: 0
      },
      client: {},
      emailvalid: false,
      emailList: [],
      emailFormSubmitted: true,
      invoiceActivities: [],
      cacheBust: Date.now(),
      input_required: value => !!value || 'Required.',
      emailRules:
        v => {
          if (!v || v.length < 1) {
            return 'Enter one or more valid emails'
          } else if (v.length > 0) {
            for (let i = 0; i < v.length; i++) {
              if (!(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/.test(v[i]))) {
                return 'Enter one or more valid emails'
              }
            }
            return true
          } else {
            return true
          }
        },
      copyLinkLabel: 'Copy'
    }
  },
  computed: {
    error () {
      return this.$store.getters.error
    },
    loading () {
      return this.$store.getters.loading
    },
    groupLogo () {
      return this.$store.getters.group.logo
    },
    uploadLabel () {
      if (this.invoice.logo !== null && this.invoice.logo !== undefined && this.invoice.logo !== '') {
        return 'change logo'
      } else {
        return 'upload logo'
      }
    },
    downloadLink () {
      return `${this.site_url}/html2pdf?g=${this.user.group}&i=${this.invoice.id}&n=${this.invoice.invoice_ref}&c=${this.cacheBust}`
    },
    customerLink () {
      return `${this.site_url}/customerinvoice/${this.user.group}/${this.invoice.id}`
    },
    displayedInvoiceNumber () {
      if (this.group.autoIncrement && this.invoice.invoice_ref === '') {
        return `${this.group.autoIncrementPrefix}${this.group.nextNumber}`
      } else {
        return this.invoice.invoice_ref
      }
    },
    truncatedNoteText () {
      if (this.invoice.note.length > 25) {
        return `${this.invoice.note.slice(0, 25)}&hellip;`
      }
      return this.invoice.note
    },
    site_url () {
      if (location.hostname === 'localhost') {
        return 'http://localhost:5050'
      } else {
        return process.env.VUE_APP_SITEURI
      }
    },
    mobileStatusText () {
      if (this.invoice.status === 'Unsent') {
        return 'Send'
      } else if (this.invoice.status === 'Sent') {
        return 'Sent'
      } else {
        return this.invoice.status
      }
    }
  },
  watch: {
    invoice (newValue, oldValue) {
      // when invoice is loaded in get a new line item ket ready to go
      this.getLineItemKey()
      // also setup the email defaults
      this.setEmailDefauts()
    }
  },
  methods: {
    onDismissed () {
      this.$store.dispatch('clearError')
    },
    reRollCachebust () {
      this.cacheBust = Date.now()
    },
    startTour () {
      this.$refs.invoiceTour.startTour()
    },
    stopTour () {
      // called from the Board component when leaving the route to ensure we dont keep showing the tour if we navigate away
      this.$refs.invoiceTour.stopTour()
    },
    openDropdownMenu () {
      this.saveButDropDownState = true
    },
    closeDropdownMenu () {
      this.saveButDropDownState = false
    },
    gotoTab (tabname) {
      this.showPanel = tabname
    },
    setEmailDefauts () {
      this.emailMessage = `Hi, here is your invoice ${this.displayedInvoiceNumber} from ${this.group.title}.`
      this.emailSubject = `Invoice from ${this.group.title}`
    },
    copyCustomerLink () {
      this.copyLinkLabel = 'Copied!'
      navigator.clipboard.writeText(this.customerLink).then(() => {
        /* clipboard successfully set */
        this.$store.dispatch('addNotification', { text: 'Link to customer invoice copied to clipboard.', type: 'primary' })
        // change the text back after 2 seconds
        setTimeout(() => {
          this.copyLinkLabel = 'Copy'
        }, 2000)
      }, function () {
        /* clipboard write failed */
      })
    },
    clickedShowDetailModal: function (value) {
      const invoiceId = this.invoice.id
      const groupId = this.user.group
      // get key
      const ref = firebase.database().ref('invoices/' + groupId + '/' + invoiceId + '/lineItems').push().key
      // build object
      const item = {
        id: ref,
        description: value.description,
        amount: value.amount,
        creatorId: this.user.id
      }
      this.$set(this.invoice.lineItems, ref, item)
    },
    async clickedShowClientDetailsModal (value) {
      // take value object from modal and use spread to merge them into the invoice
      const newInvoice = {
        ...this.invoice,
        ...value
      }
      // save it to local invoice
      this.invoice = newInvoice
      // update the invoice emailList
      this.emailList = value.emails
      // save the invoice
      await this.onSaveInvoice()
      // dispatch notification
      this.$store.dispatch('addNotification', { text: 'Invoice saved.', type: 'primary' })
    },
    async clickedShowBusinessDetailsModal (value) {
      // take value object from modal and use spread to merge them into the invoice
      const newInvoice = {
        ...this.invoice,
        ...value
      }
      // save it to local invoice
      this.invoice = newInvoice
      // save the invoice
      await this.onSaveInvoice()
      // dispatch notification
      this.$store.dispatch('addNotification', { text: 'Invoice saved.', type: 'primary' })
    },
    async clickedShowPaymentDetailsModal (value) {
      // take value object from modal and use spread to merge them into the invoice
      const newInvoice = {
        ...this.invoice,
        ...value
      }
      // save it to local invoice
      this.invoice = newInvoice
      // save the invoice
      await this.onSaveInvoice()
      // dispatch notification
      this.$store.dispatch('addNotification', { text: 'Invoice saved.', type: 'primary' })
    },
    async clickedShowInvoiceDetailsModal (value) {
      this.invoice.invoice_ref = value.invoice_ref
      this.invoice.poNumber = value.poNumber
      this.invoice.invoiced_date = value.invoiced_date
      this.invoice.note = value.note
      this.invoicedDateFormatted = value.invoicedDateFormatted

      // save the invoice
      await this.onSaveInvoice()
      // dispatch notification
      this.$store.dispatch('addNotification', { text: 'Invoice saved.', type: 'primary' })
    },
    async returningInvoiceNumber (value) {
      this.invoice.invoice_ref = value.invoice_ref
      // save the invoice
      await this.onSaveInvoice()
      // dispatch notification
      this.$store.dispatch('addNotification', { text: 'Invoice saved.', type: 'primary' })
    },
    async returningInvoiceEmailTo (value) {
      this.emailList = value.emailList
      // save the emails to this.client
      this.client.emails = this.emailList
      // save the client
      await firebase.database().ref('clients/' + this.user.group + '/' + this.client.id + '/emails').set(this.emailList)

      // dispatch notification
      this.$store.dispatch('addNotification', { text: 'Client email updated.', type: 'primary' })
    },
    async onDeleteLineItem (itemId) {
      if (await this.$refs.confirm.open('Delete', 'Are you sure?', { color: 'red' })) {
        this.$delete(this.invoice.lineItems, itemId)
      }
    },
    async onSaveAndDownload () {
      if (await this.$refs.getInvoiceNumber.open()) {
        // assign the number if not already
        this.safelyAssignInvoiceRef()
        // save the invoice
        this.onSaveInvoice()

        // if we are not yet in column 4/invoice then prompt to move it
        const JobListId = this.$store.getters.getListIdFromJobId(this.invoice.id)
        if (JobListId !== 4) {
          if (await this.$refs.confirm.open('Marked as sent', 'If you are downloading to attach in an email, would you like us to mark it as sent and move the job to the Invoiced column?', { color: 'red', negative: 'no' })) {
            await this.onSaveAndMarkAsSent()
          } else {
            await this.onSaveInvoice()
          }
        } else {
          await this.onSaveInvoice()
        }
        // now start the loader
        this.pdfLoading = true
        // and download the PDF
        this.getPdf()
        // reroll the cachebuster so we dont redownload a cached PDF
        this.reRollCachebust()
      }
    },
    onDownload () {
      // now start the loader
      this.pdfLoading = true
      // and download the PDF
      this.getPdf()
    },
    getPdf () {
      // create a link element and give it the download attribute and href
      // the download attribute is important to stop browsers popup blocking
      var link = document.createElement('a')
      link.href = this.downloadLink
      link.download = true
      // now click the element we just made
      link.dispatchEvent(new MouseEvent('click'))
    },
    async onSaveAndMarkAsSent () {
      // if prompt for invoice number is complete then do the update
      if (await this.$refs.getInvoiceNumber.open()) {
        // start loader
        this.$store.commit('setLoading', true)

        if (await this.$refs.getInvoiceEmailTo.open()) {
          try {
            // assign the number if not already
            this.safelyAssignInvoiceRef()
            // set the invoice to Sent
            this.invoice.status = 'Sent'
            this.invoice.sentTimeStamp = this.formatDateToISO(Date.now())
            // Save the invoice
            await this.onSaveInvoice()
            // build the activity Msg
            const activityMsg = {
              status: 'Marked as sent',
              by: this.user.email,
              created: this.formatDateToISO(Date.now())
            }
            // Save the activity Msg to the timeline
            await firebase.database().ref('invoices-activity/' + this.user.group + '/' + this.itemId).push(activityMsg)
            // get the listId of the Job
            const JobListId = this.$store.getters.getListIdFromJobId(this.invoice.id)
            // setup the notification text
            let activityText = 'Invoice marked as Sent'
            // if we are not in the invoice column lets move the job there as it's now marked as sent
            if (JobListId !== 4) {
              await this.$store.dispatch('moveJob', { jobId: this.invoice.id, oldList: JobListId, newList: 4 })
              // amend the notification text to say that the job moved columns
              activityText = 'Marked as sent, moved to the invoiced column.'
            }
            // all is well so stop the loader..
            this.$store.commit('setLoading', false)
            // and dispatch the notification
            this.$store.dispatch('addNotification', { text: activityText, type: 'primary' })
          } catch (error) {
            this.$store.commit('setError', error)
            this.$store.commit('setLoading', false)
          }
        }
      }
    },
    async onMarkAsUnSent () {
      // if prompt for invoice number is complete then do the update
      if (await this.$refs.getInvoiceNumber.open()) {
        // start loader
        this.$store.commit('setLoading', true)
        try {
          // set the invoice to Unsent
          this.invoice.status = 'Unsent'
          this.invoice.sentTimeStamp = ''

          // Save the invoice
          await this.onSaveInvoice()
          // build the activity Msg
          const activityMsg = {
            status: 'Marked as unsent',
            by: this.user.email,
            created: this.formatDateToISO(Date.now())
          }
          // Save the activity Msg to the timeline
          await firebase.database().ref('invoices-activity/' + this.user.group + '/' + this.itemId).push(activityMsg)
          // get the listId of the Job
          const JobListId = this.$store.getters.getListIdFromJobId(this.invoice.id)
          // setup the notification text
          let activityText = 'Invoice marked as Unsent'
          // if we are not in the invoice column lets move the job there as it's now marked as sent
          if (JobListId === 4) {
            await this.$store.dispatch('moveJob', { jobId: this.invoice.id, oldList: JobListId, newList: 3 })
            // amend the notification text to say that the job moved columns
            activityText = 'marked as unsent, moved to the current column.'
          }

          // all is well so stop the loader..
          this.$store.commit('setLoading', false)
          // and dispatch the notification
          this.$store.dispatch('addNotification', { text: activityText, type: 'primary' })
        } catch (error) {
          this.$store.commit('setError', error)
          this.$store.commit('setLoading', false)
        }
      }
    },
    async onMarkAsPaid () {
      // if prompt for invoice number is complete then do the update
      if (await this.$refs.getInvoiceNumber.open()) {
        // start loader
        this.$store.commit('setLoading', true)
        try {
          // set the invoice to Paid
          this.invoice.status = 'Paid'
          // update the local invoice object paid date to now
          var d = new Date()
          this.invoice.paid_date = d.toISOString()
          // Save the invoice
          await this.onSaveInvoice()
          // build the activity Msg
          const activityMsg = {
            status: 'Marked as paid',
            by: this.user.email,
            created: this.formatDateToISO(Date.now())
          }
          // Save the activity Msg to the timeline
          await firebase.database().ref('invoices-activity/' + this.user.group + '/' + this.itemId).push(activityMsg)
          // get the listId of the Job
          const JobListId = this.$store.getters.getListIdFromJobId(this.invoice.id)
          // setup the notification text
          let activityText = 'Invoice marked as Paid'
          // if we are not in the invoice column lets move the job there as it's now marked as sent
          if (JobListId !== 5) {
            await this.$store.dispatch('moveJob', { jobId: this.invoice.id, oldList: JobListId, newList: 5 })
            // amend the notification text to say that the job moved columns
            activityText = 'Marked as paid, moved to the paid column.'
          }
          // all is well so stop the loader..
          this.$store.commit('setLoading', false)
          // and dispatch the notification
          this.$store.dispatch('addNotification', { text: activityText, type: 'primary' })
        } catch (error) {
          this.$store.commit('setError', error)
          this.$store.commit('setLoading', false)
        }
      }
    },
    async onMarkAsUnPaid () {
      // if prompt for invoice number is complete then do the update
      if (await this.$refs.getInvoiceNumber.open()) {
        // start loader
        this.$store.commit('setLoading', true)
        try {
          // set the invoice to Paid
          this.invoice.status = 'Sent'
          // update the local invoice object paid date to blank
          this.invoice.paid_date = ''
          // Save the invoice
          await this.onSaveInvoice()
          // build the activity Msg
          const activityMsg = {
            status: 'Marked as unpaid',
            by: this.user.email,
            created: this.formatDateToISO(Date.now())
          }
          // Save the activity Msg to the timeline
          await firebase.database().ref('invoices-activity/' + this.user.group + '/' + this.itemId).push(activityMsg)
          // get the listId of the Job
          const JobListId = this.$store.getters.getListIdFromJobId(this.invoice.id)
          // setup the notification text
          let activityText = 'Invoice marked as Unpaid'
          // if we are not in the invoice column lets move the job there as it's now marked as sent
          if (JobListId === 5) {
            await this.$store.dispatch('moveJob', { jobId: this.invoice.id, oldList: JobListId, newList: 4 })
            // amend the notification text to say that the job moved columns
            activityText = 'Invoice marked as Unpaid and moved to the Invoiced column.'
          }
          // all is well so stop the loader..
          this.$store.commit('setLoading', false)
          // and dispatch the notification
          this.$store.dispatch('addNotification', { text: activityText, type: 'primary' })
        } catch (error) {
          this.$store.commit('setError', error)
          this.$store.commit('setLoading', false)
        }
      }
    },
    async onChaseSwitchChange () {
      // if we are switching on chaseable and the email prompt is complete then do the update
      if (this.invoice.chaseable && await this.$refs.getInvoiceEmailTo.open()) {
        await this.onSaveInvoice()
        // dispatch notification
        this.$store.dispatch('addNotification', { text: 'Invoice saved.', type: 'primary' })
      } else {
        // else we are switching off chaseable so just do the update
        this.invoice.chaseable = false
        await this.onSaveInvoice()
        this.$store.dispatch('addNotification', { text: 'Invoice saved.', type: 'primary' })
      }
    },
    async onStripeSwitchChange () {
      await this.onSaveInvoice()
      // dispatch notification
      this.$store.dispatch('addNotification', { text: 'Invoice saved.', type: 'primary' })
    },
    async onlinePaymentsChange (value) {
      this.group.onlinePaymentsOn = value
      this.invoice.payable = value
      await this.onSaveInvoice()
      // dispatch notification
      // this.$store.dispatch('addNotification', { text: 'Invoice saved.', type: 'primary' })
    },
    async onSaveAndGoToStripe () {
      if (await this.$refs.getInvoiceNumber.open()) {
        this.$store.commit('setLoading', true)
        this.invoice.status = 'Unsent'
        this.onSaveInvoice()
        const activityMsg = {
          status: 'Saved as a draft',
          by: this.user.email,
          created: this.formatDateToISO(Date.now())
        }
        firebase.database().ref('invoices-activity/' + this.user.group + '/' + this.itemId).push(activityMsg)
          .then((data) => {
            this.$store.commit('setLoading', false)
            this.$store.dispatch('addNotification', { text: 'Invoice saved.', type: 'primary' })
            this.$router.push('/settings/payments')
          })
          .catch((error) => {
            this.$store.commit('setError', error)
            this.$store.commit('setLoading', false)
          })
      }
    },
    safelyAssignInvoiceRef () {
      // if there is no invoice_ref and we are autoincrementing then lets do it
      if (this.invoice.invoice_ref === '' && this.group.autoIncrement) {
        // assign the next number and prefix to the invoice invoice_ref
        this.invoice.invoice_ref = `${this.group.autoIncrementPrefix}${this.group.nextNumber}`
        // increment the group number up one
        this.group.nextNumber = this.incrementAndMaintainNumberPadding(this.group.nextNumber)
        // save the group with the updated number
        // TODO at the moment using the json  stringify then parse ensures no undefined values are present - a bit hacky and may have overhead - investigate
        this.$store.dispatch('updateGroupSettings', JSON.parse(JSON.stringify(this.group)))
      }
    },
    async onSaveInvoice () {
      // start loader
      this.$store.commit('setLoading', true)
      // get new logo details
      this.group.logoWidth = this.invoice.logoWidth
      this.group.logoAlign = this.invoice.logoAlign
      this.group.useLogo = this.invoice.useLogo
      this.group.logoName = this.invoice.logoName
      this.group.logoNameSize = this.invoice.logoNameSize

      // get the corresponding job's listId so we can also update the job
      const JobListId = this.$store.getters.getListIdFromJobId(this.invoice.id)
      // if this a new save and autoIncrement is ON then get a new invoice_ref number
      // .. but if its the first invoice then leave it as is
      // TODO - remove this if statement to a 'complete invoice function or lockin invoice function'
      // if (this.isNewInvoice && this.group.autoIncrement && !this.group.isFirstInvoice) {
      //   // increase the global autoIncrement number (with any zero padding)
      //   this.group.nextNumber = this.incrementAndMaintainNumberPadding(this.group.nextNumber)
      // }
      // all good, lets do the database stuff now and get it saved
      try {
        // save any new group level details to the group, logo, payment terms etc
        // TODO at the moment using the json  stringify then parse ensures no undefined values are present - a bit hacky and may have overhead - investigate
        // this removes the newlogo Fileobject part of the group when its stringifyd so cant use it
        // this.$store.dispatch('updateGroupSettings', JSON.parse(JSON.stringify(this.group)))
        this.$store.dispatch('updateGroupSettings', this.group)
        // reset the data holders
        this.invoice.logo = this.groupLogo
        this.invoice.newLogo = ''
        this.group.newLogo = ''
        // save the invoice
        // await firebase.database().ref(`invoices/${this.user.group}/${this.itemId}`).set(this.invoice)
        await this.$store.dispatch('saveInvoice', this.invoice)
        // if there is a matching job update it
        if (JobListId !== null) {
          // create an object to update the corresponding job with
          const jobUpdate = {
            title: this.invoice.title,
            amount: this.invoice.amount,
            invoice_ref: this.invoice.invoice_ref,
            taxIncluded: this.invoice.taxIncluded,
            totalNetAmount: this.invoice.totalNetAmount,
            totalTaxPortion: this.invoice.totalTaxPortion,
            lineItems: this.invoice.lineItems,
            hasInvoice: true,
            clientName: this.invoice.clientName,
            invoiced_date: this.invoice.invoiced_date
          }
          // update the corresponding job
          await firebase.database().ref(`lists/${this.user.group}/list${JobListId}/${this.itemId}/`).update(jobUpdate)
        }
        // this is no longer a newInvoice so set it to false
        this.isNewInvoice = false
      } catch (error) {
        this.$store.commit('setError', error)
        this.$store.commit('setLoading', false)
        Promise.reject(error)
      }
    },
    async onDeleteInvoice () {
      if (await this.$refs.confirm.open('Delete Invoice', 'Are you sure you want to delete this invoice?', { color: 'red' })) {
        // Deletes both the invoice and any invoices-activities from Firebase
        this.$store.commit('setLoading', true)
        try {
          var updates = {}
          updates['invoices/' + this.user.group + '/' + this.itemId] = null
          updates['invoices-activity/' + this.user.group + '/' + this.itemId] = null
          await firebase.database().ref().update(updates)
          // the remove chase queue items callable, do it on server for security as we cant let everyone access the queue
          const removeChaseQueueItems = firebase.functions().httpsCallable('chaseEmails-removeQueueItemsForChaseEmails')
          // call it with the group and invoice,
          await removeChaseQueueItems({ invoiceId: this.itemId, groupId: this.user.group })
          // update the job card
          const jobUpdate = {
            invoice_ref: '',
            hasInvoice: false,
            invoiced_date: ''
          }
          const JobListId = this.$store.getters.getListIdFromJobId(this.invoice.id)
          // if there is a matching job update it
          if (JobListId !== null && JobListId !== undefined) {
            await firebase.database().ref(`lists/${this.user.group}/list${JobListId}/${this.itemId}/`).update(jobUpdate)
          }
          // if the job is in the invoiced column ask if they want to move it back to current
          if ((JobListId === 4) && (await this.$refs.confirm.open('Move job?', 'Do you want to move the job back to Current?', { color: 'red', negative: 'no' }))) {
            await this.$store.dispatch('moveJob', { jobId: this.invoice.id, oldList: JobListId, newList: 3 })
          }
          this.$store.commit('setLoading', false)
          this.$store.dispatch('addNotification', { text: 'Invoice deleted.', type: 'error' })
          this.$router.go(-1)
        } catch (error) {
          this.$store.commit('setError', error)
          this.$store.commit('setLoading', false)
        }
      }
    },
    async updateInvoiceFromLineItems (payload) {
      // create replacement Job object with updated items from lineItems component
      const newInvoice = {
        ...this.invoice,
        amount: payload.amount,
        totalTaxPortion: payload.totalTaxPortion,
        totalNetAmount: payload.totalNetAmount,
        title: payload.title,
        taxIncluded: payload.taxIncluded,
        lineItems: payload.lineItems
      }
      // save it to local invoice
      this.invoice = newInvoice
      // save the invoice
      await this.onSaveInvoice()
      // dispatch notification
      this.$store.dispatch('addNotification', { text: 'Invoice saved.', type: 'primary' })
    },
    getLineItemKey () {
      const invoiceId = this.invoice.id
      const groupId = this.user.group
      const ref = firebase.database().ref('invoices/' + groupId + '/' + invoiceId + '/lineItems').push().key
      this.newLineItemKey = ref
    },
    onPickFile () {
      this.$refs.fileInput.click()
    },
    onFilePicked (event) {
      // takes the file input's image
      const files = event.target.files
      let filename = files[0].name
      // quick validation
      if (filename.lastIndexOf('.') <= 0) {
        return alert('Please add a valid file!')
      }
      // read theimage to base64 only when finished load
      // and add to data imageUrl
      const fileReader = new FileReader()
      fileReader.addEventListener('load', () => {
        this.imageUrl = fileReader.result
      })
      fileReader.readAsDataURL(files[0])
      // also store the image itself
      this.invoice.newLogo = files[0]
      this.group.newLogo = files[0]
      // save the invoice
      this.onSaveInvoice()
    },
    removeLogo () {
      this.$refs.fileInput.value = null
      this.invoice.newLogo = null
      this.group.newLogo = null
      this.imageUrl = null
      this.invoice.logo = null
      this.group.logo = null
      // TODO remove the file from firebase storage save money!
    },
    async onOpenEmail () {
      if (await this.$refs.getInvoiceNumber.open()) {
        this.$refs.emailForm.resetValidation()
        this.setEmailDefauts()
        this.emailDialog = true
      }
    },
    async onSendEmail () {
      if (await this.$refs.getInvoiceNumber.open()) {
        this.$store.commit('setLoading', true)
        try {
          // first assign the number if not already done
          this.safelyAssignInvoiceRef()
          // then set the send timestamp - this also gets uopdated in the Sending Cloud function
          // but we need it now to base the chase emails schedule off when it runs on server
          this.invoice.sentTimeStamp = this.formatDateToISO(Date.now())
          // then save the invoice to Firebase
          await this.onSaveInvoice()
          // build the emailMsg object to save in Firebase activity
          const emailMsg = {
            to: this.emailList,
            fromName: this.emailFromName,
            from: this.emailFrom,
            subject: this.emailSubject,
            message: this.emailMessage,
            created: this.formatDateToISO(Date.now()),
            status: 'Sending'
          }
          // save the object in FB which will trigger a cloud function to send the email
          // the cloud function will also update the status to sent when done
          await firebase.database().ref('invoices-activity/' + this.user.group + '/' + this.itemId).push(emailMsg)
          // save the emails to local this.client onbject
          this.client.emails = this.emailList
          // save the emails to the fb client for next time
          await firebase.database().ref('clients/' + this.user.group + '/' + this.client.id + '/emails').set(this.emailList)
          this.$store.commit('setLoading', false)
          this.$store.dispatch('addNotification', { text: 'Invoice sent.', type: 'primary' })
          // this.emailSubject = ''
          // this.emailMessage = ''
          this.emailFormSubmitted = false
          // this fakes the sent status so that the page immediately updates buttons etc without a reload.
          // The Cloud Function will set this again in a few seconds anyway or will show a fail
          this.invoice.status = 'Sent'
          // check if there are chaseemails to be sent and write them to the db and activity stream
          this.emailDialog = false
        } catch (error) {
          this.$store.commit('setError', error)
          this.$store.commit('setLoading', false)
        }
      }
    },
    async onCopyLink () {
      const customerInvoiceLink = `${this.site_url}/customerinvoice/${this.user.group}/${this.invoice.id}`
      // if we are not yet in column 4/invoice then prompt to move it
      const JobListId = this.$store.getters.getListIdFromJobId(this.invoice.id)
      if (JobListId !== 4) {
        if (await this.$refs.confirm.open('Marked as sent', 'Would you like us to mark the invoice as sent and move the job to the Invoiced column?', { color: 'red', negative: 'no' })) {
          await this.onSaveAndMarkAsSent()
        } else {
          await this.onSaveInvoice()
        }
      } else {
        await this.onSaveInvoice()
      }
      navigator.clipboard.writeText(customerInvoiceLink).then(() => {
      /* clipboard successfully set */
        this.$store.dispatch('addNotification', { text: 'Link copied to clipboard.', type: 'primary' })
      }, function () {
        /* clipboard write failed */
      })
    },
    firstInvoiceWizardDone () {
      this.group.isFirstInvoice = false
      // if its the end of the wizard lets take their chosen invoice_ref and store the incremented version for next time
      // this.group.nextNumber = this.incrementAndMaintainNumberPadding(this.group.nextNumber)
      this.group.logoAlign = this.invoice.logoAlign
      this.group.logoWidth = this.invoice.logoWidth
      this.group.newLogo = this.invoice.newLogo
      this.group.paymentTerms = this.invoice.paymentTerms
      this.group.companyAddress = this.invoice.groupAddress
      this.group.groupAddress1 = this.invoice.groupAddress1
      this.group.groupAddress2 = this.invoice.groupAddress2
      this.group.groupCityRegion = this.invoice.groupCityRegion
      this.group.groupCountyState = this.invoice.groupCountyState
      this.group.groupPostcode = this.invoice.groupPostcode
      this.group.groupCountry = this.invoice.groupCountry
      this.group.chargeTax = this.invoice.chargeTax
      this.group.taxRate = this.invoice.taxRate
      this.group.useLogo = this.invoice.useLogo
      this.group.logoName = this.invoice.logoName
      this.group.logoNameSize = this.invoice.logoNameSize
      // TODO at the moment using the json  stringify then parse ensures no undefined values are present - a bit hacky and may have overhead - investigate
      this.$store.dispatch('updateGroupSettings', JSON.parse(JSON.stringify(this.group)))
      this.$store.dispatch('addNotification', { text: 'Invoice defaults saved.', type: 'primary' })
      this.group.newLogo = null
      this.onSaveInvoice()
      this.startTour()
    },
    fetchData () {
      const itemId = this.$route.params.invoice_id
      // check for existing invoice, if so grab all items from this
      this.$store.commit('setLoading', true)
      // load invoice activities in and watch for child_added so we can react to
      // each one. eg the downloaded one turns off the loading spinner
      const activityRef = firebase.database().ref(`invoices-activity/${this.user.group}/${this.itemId}`)
      activityRef.on('child_added', (data) => {
        // const activities = []
        const invoiceActivityObj = data.val()
        if (invoiceActivityObj.status === 'Downloaded') {
          this.pdfLoading = false
        }
        this.invoiceActivities.push(invoiceActivityObj)
      })
      // if an activity gets changed it will be the invoice Sending => Invoice Sent status
      activityRef.on('child_changed', (data) => {
        // const activities = []
        const invoiceActivityObj = data.val()
        if (invoiceActivityObj.status === 'Sent') {
          // if this is a Sending to Sent change then pop the Sent status off the displayed list
          this.invoiceActivities.pop()
          // and shove the new Sent one in there
          this.invoiceActivities.push(invoiceActivityObj)
        }
      })
      // if an activty gets removed then remove it from here too
      activityRef.on('child_removed', (data) => {
        // const activities = []
        const invoiceActivityObj = data.val()
        const activityArray = this.invoiceActivities.filter(function (f) { return f.queueItemId !== invoiceActivityObj.queueItemId })
        this.invoiceActivities = activityArray
      })

      // so grab invoice ...
      firebase.database().ref('invoices/' + this.user.group + '/' + this.itemId).once('value')
        .then(async data => {
          if (data.val() !== null) {
            // it's an existing invoice, lets populate the data and show the delete button
            this.isNewInvoice = false
            this.invoice = {
              ...this.invoice,
              ...data.val()
            }
            this.deadlineDateFormatted = this.formatDate(this.invoice.deadline_date)
            this.invoicedDateFormatted = this.formatDate(this.invoice.invoiced_date)

            // also grab the clients email addresses if they exist to prepopulate the email form
            if (this.invoice.clientName !== '') {
              let clientObj = ''
              const thisclientname = this.invoice.clientName

              if (this.$store.getters.clients.filter(function (client) { return client.name === thisclientname }).length > 0) {
                clientObj = this.$store.getters.clients.filter(function (client) { return client.name === thisclientname })
              }
              if (clientObj !== null) {
                // add the client object to the component
                this.client = clientObj[0]
                if (typeof clientObj[0].emails !== 'undefined') {
                  this.emailList = clientObj[0].emails
                }
              }
            }
            // all done
            this.isDataLoaded = true
            this.$store.commit('setLoading', false)
          } else {
            // else populate the job details from the job
            // and the default company details fro company
            // get job details from the job by going through every job in all 5 lists
            let jobObj = ''
            if (this.$store.getters.list1.filter(function (job) { return job.id === itemId }).length > 0) {
              jobObj = this.$store.getters.list1.filter(function (job) { return job.id === itemId })
            }
            if (this.$store.getters.list2.filter(function (job) { return job.id === itemId }).length > 0) {
              jobObj = this.$store.getters.list2.filter(function (job) { return job.id === itemId })
            }
            if (this.$store.getters.list3.filter(function (job) { return job.id === itemId }).length > 0) {
              jobObj = this.$store.getters.list3.filter(function (job) { return job.id === itemId })
            }
            if (this.$store.getters.list4.filter(function (job) { return job.id === itemId }).length > 0) {
              jobObj = this.$store.getters.list4.filter(function (job) { return job.id === itemId })
            }
            if (this.$store.getters.list5.filter(function (job) { return job.id === itemId }).length > 0) {
              jobObj = this.$store.getters.list5.filter(function (job) { return job.id === itemId })
            }
            // add the details to the page's invoice data
            if (jobObj !== null) {
              if (jobObj[0].title !== null) {
                this.invoice.title = jobObj[0].title
              }
              if (jobObj[0].clientName !== null) {
                this.invoice.clientName = jobObj[0].clientName
              }
              if (jobObj[0].amount !== null) {
                this.invoice.amount = jobObj[0].amount
              }
              if (jobObj[0].taxIncluded !== null) {
                this.invoice.taxIncluded = jobObj[0].taxIncluded
              }
              if (jobObj[0].totalNetAmount !== null) {
                this.invoice.totalNetAmount = jobObj[0].totalNetAmount
              }
              if (jobObj[0].totalTaxPortion !== null) {
                this.invoice.totalTaxPortion = jobObj[0].totalTaxPortion
              }
              if (jobObj[0].contact !== null) {
                this.invoice.contact = jobObj[0].contact
              }
              // if ((jobObj[0].invoice_ref !== null) && (!this.group.autoIncrement)) {
              //   this.invoice.invoice_ref = jobObj[0].invoice_ref
              // } else if (this.group.autoIncrement) {
              //   this.invoice.invoice_ref = this.group.autoIncrementPrefix + this.group.nextNumber
              // }
              if ((jobObj[0].invoiced_date !== null) && (jobObj[0].invoiced_date !== '')) {
                this.invoice.invoiced_date = jobObj[0].invoiced_date
              } else {
                // const millis = Date.now()
                this.invoice.invoiced_date = this.formatDateToISOShort(Date.now())
              }
              if (jobObj[0].paid_date !== null) {
                this.invoice.paid_date = jobObj[0].paid_date
              }
              if (jobObj[0].lineItems !== undefined) {
                this.invoice.lineItems = jobObj[0].lineItems
              } else {
                var thisline = { 'description': jobObj[0].title, 'amount': jobObj[0].amount }
                this.invoice.lineItems[0] = thisline
              }
            }
            // add the clients details to the page's invoice data
            if (this.invoice.clientName !== '') {
              let clientObj = ''
              const thisclientname = this.invoice.clientName

              if (this.$store.getters.clients.filter(function (client) { return client.name === thisclientname }).length > 0) {
                clientObj = this.$store.getters.clients.filter(function (client) { return client.name === thisclientname })
              }
              if (clientObj !== null) {
              // add the client object to the component
                this.client = clientObj[0]
                // add emails to the emai list
                this.emailList = clientObj[0].emails || []

                // if emails exist then set chaseable to true
                if (this.emailList.length > 0) {
                  this.invoice.chaseable = true
                } else {
                  this.invoice.chaseable = false
                }

                // merge the clients address in
                if (clientObj[0].address !== null && clientObj[0].address !== undefined) {
                  this.invoice.clientAddress = clientObj[0].address
                }
                if (clientObj[0].address2 !== null && clientObj[0].address2 !== undefined) {
                  this.invoice.clientAddress2 = clientObj[0].address2
                }
                if (clientObj[0].town !== null && clientObj[0].town !== undefined) {
                  this.invoice.clientTown = clientObj[0].town
                }
                if (clientObj[0].county !== null && clientObj[0].county !== undefined) {
                  this.invoice.clientCounty = clientObj[0].county
                }
                if (clientObj[0].country !== null && clientObj[0].country !== undefined) {
                  this.invoice.clientCountry = clientObj[0].country
                }
                if (clientObj[0].postCode !== null && clientObj[0].postCode !== undefined) {
                  this.invoice.postCode = clientObj[0].postCode
                }
                if (clientObj[0].contact !== null && clientObj[0].contact !== undefined) {
                  this.invoice.contact = clientObj[0].contact
                }
              }
            }

            // get the projects group's defaults into the invoice too
            if (this.invoice.chargeTax === '' && this.group.chargeTax !== null) {
              this.invoice.chargeTax = this.group.chargeTax
            }
            if (this.invoice.taxLabel === '' && this.group.taxLabel !== null) {
              this.invoice.taxLabel = this.group.taxLabel
            } else {
              this.invoice.taxLabel = 'VAT'
            }
            if (this.invoice.taxRate === '' && this.group.taxRate !== null) {
              this.invoice.taxRate = this.group.taxRate
            }
            if (this.group.groupTitle !== null) {
              this.invoice.groupTitle = this.group.title
            }
            if (this.group.companyAddress !== null) {
              this.invoice.groupAddress = this.group.companyAddress
            }
            if (this.group.groupAddress1 !== null) {
              this.invoice.groupAddress1 = this.group.groupAddress1
            }
            if (this.group.groupAddress2 !== null) {
              this.invoice.groupAddress2 = this.group.groupAddress2
            }
            if (this.group.groupCityRegion !== null) {
              this.invoice.groupCityRegion = this.group.groupCityRegion
            }
            if (this.group.groupCountyState !== null) {
              this.invoice.groupCountyState = this.group.groupCountyState
            }
            if (this.group.groupPostcode !== null) {
              this.invoice.groupPostcode = this.group.groupPostcode
            }
            if (this.group.groupCountry !== null) {
              this.invoice.groupCountry = this.group.groupCountry
            }
            if (this.group.logo !== null) {
              this.invoice.logo = this.group.logo
            }
            if (this.group.paymentTerms !== null) {
              this.invoice.paymentTerms = this.group.paymentTerms
            }
            if (this.group.logoWidth !== null) {
              this.invoice.logoWidth = this.group.logoWidth
            }
            if (this.group.logoAlign !== null) {
              this.invoice.logoAlign = this.group.logoAlign
            }

            if ((typeof this.group.onlinePaymentsOn !== 'undefined') && (this.group.onlinePaymentsOn !== 'false')) {
              this.invoice.payable = this.group.onlinePaymentsOn
            }

            // finaly update the date holders for formatting
            this.deadlineDateFormatted = this.invoice.deadline_date
            this.invoicedDateFormatted = this.formatDate(this.invoice.invoiced_date)

            await this.onSaveInvoice()
            const activityMsg = {
              status: 'Invoice created',
              by: this.user.email,
              created: this.formatDateToISO(Date.now())
            }
            firebase.database().ref('invoices-activity/' + this.user.group + '/' + this.itemId).push(activityMsg)
              .then((data) => {
                this.$store.commit('setLoading', false)
                this.$store.dispatch('addNotification', { text: 'Invoice created.', type: 'primary' })
              })
              .catch((error) => {
                this.$store.commit('setError', error)
                this.$store.commit('setLoading', false)
              })

            this.$store.commit('setLoading', false)
            this.isDataLoaded = true
          }// endif is this a new invoice or not
        })
        .catch(
          (error) => {
            Promise.reject(error)
            this.$store.commit('setError', error)
            this.$store.commit('setLoading', false)
          }
        )
    },
    liveUpdateInvoiceNumber () {
      // we call this whenever the invoice-number-format component is updated within the first invoice wizard
      // if we're using autonubering
      if (this.group.autoIncrement) {
        // it injects the new ref into the invoice.invoice_ref
        this.invoice.invoice_ref = `${this.group.autoIncrementPrefix}${this.group.nextNumber}`
      } else {
        // else we clear the number from the invoice
        this.invoice.invoice_ref = ''
      }
    }
  },
  created () {
    this.fetchData()
    this.getLineItemKey()
  },
  mounted () {
    const stripeIntoFlag = this.$route.query.sc
    if (stripeIntoFlag) {
      this.showStripeModal = true
    }
  },
  async beforeRouteLeave (to, from, next) {
    if (this.isNewInvoice) {
      if (!await this.$refs.confirm.open('Invoice not saved', 'Are you sure you want to leave?', { color: 'red' })) {
        return
      }
    }
    next()
  }
}
</script>
<style lang="scss" scoped>

.bottab{
  opacity:0.4;
  font-weight:bold;
  .span{
    font-weight:bold;
  }
}
.v-item-group.v-bottom-nav .v-btn.bottab{
  opacity:0.4;
  font-weight:bold;
  .v-btn__content{
    span{
      font-size:14px;
    }
  }
}
.v-item-group.v-bottom-nav .v-btn.bottabon{
  opacity:1;
}
.uploadholder{
  cursor:pointer;
}

.invoice-toolbar{
  top:50px;
}
.invoice-builder{
  margin-top:30px;
  // display: flex;
  .xsOnly &{
    margin-top:15px;
  }
}

.invoice-editor-panel {
    bottom: 0;
    left: 0;
    position: fixed;
    top: 50px;
    // width: 20%;
    width:320px;
    background-color:var(--secondary);
    overflow-y: scroll;
    overflow-x: auto;
  .xsOnly &{
      width:100%;
      top:50px;
      margin-bottom:50px;
      // height: calc(100vh - 118px); // height of page minus two bars
  }
  .condensed &{
    top:40px;
  }
  .v-input input, .v-textarea textarea {
    font-size:14px;
  }
}

.invoice-preview-contain{
  width:45vw;
  max-width:1000px;
  margin:0 auto;
  padding:0 10px;
  .xsOnly &{
    width:100%;
  }
}

.customer-link-contain {
  width:45vw;
  max-width:1000px;
  margin:0 auto;
  padding:0 10px;
  .xsOnly &{
    width:100%;
  }
}
.customer-link{
  display:flex;
  align-items:center;
  background:#fff;
  margin-bottom:20px;
}
// make the 3 children of the customer link flex with the middle one expanding. The first and last boxes shouild stay the same size
.customer-link > *{
  flex:1;
  padding:5px 10px;
}
.customer-link > *:first-child{
  flex:0;
  border-right:1px solid #ccc;
}
.customer-link > *:last-child{
  flex:0;
}
// div with overflow hidden for a long url and don't allow the text to wrap
.customer-link > *:nth-child(2){
  overflow:hidden;
  white-space:nowrap;
  text-overflow:ellipsis;
}

.invoice-preview-panel{
  margin-left:320px;
  margin-right:280px;
  .xsOnly &{
      margin-left:0;
      margin-right:0;
      // height: calc(100vh - 118px); // height of page minus two bars
  }
  // width:50%;
}

.invoice-timeline-panel{
    bottom: 0;
    position: fixed;
    right: 0;
    top:50px;
    width: 20%;
    width:280px;
    background-color:var(--secondary);
    overflow-y: scroll;
    overflow-x: auto;
    .mdAndDown &{
    }
  .xsOnly &{
      width:100%;
      top:50px;
      margin-bottom:50px;
  }
  .condensed &{
    top:40px;
  }
}
.invoice-controls-holder{
  display:flex;
  width:100%;
  justify-content:space-between;
  align-items: center;
  .xsOnly &{
    justify-content:flex-start;

  }

}
.invoice-controls-button{
   .xsOnly &{
  flex-grow:1;
  }
}
.download-button{
    .xsOnly &{
    padding-right:20px;
  }
  &:hover{
    cursor:pointer;
  }
}
.delete-button{

  &:hover{
    cursor:pointer;
  }
}
.invoice-timeline-panel--body{
    flex: 1;
    overflow-y:scroll;
    display:flex;
    flex-direction:column;
}
.invoice-editor-panel--body{
    flex: 1;
    overflow-y:scroll;
    display:flex;
    flex-direction:column;
}

.v-stepper{
  overflow:visible;
}
.v-stepper--vertical .v-stepper__content{
  // margin: -8px 0px -4px 10px;
  // padding: 16px 16px 16px 23px;
  margin: -8px 0px -16px 36px;
    padding: 16px 30px 16px 23px;
}
.xsOnly{
  .invoice-panel{
    display:none;
  }
  .show-edit{
    .invoice-editor-panel.invoice-panel{
      display:flex;
    }
  }
  .show-preview{
    .invoice-preview-panel.invoice-panel{
      display:flex;
      flex-direction:column;
    }
  }
  .show-timeline{
    .invoice-timeline-panel.invoice-panel{
      display:block;
    }
  }
}

</style>
